import React, { useMemo, useState, useEffect } from "react";
import MaterialReactTable from "material-react-table";
import ReactModal from "react-modal";
import axios from "axios";
import { obtenerInstituciones } from "../../Services/Rest";
import { MRT_Localization_ES } from "material-react-table/locales/es";

function CopyInstitucion() {
  const columns = useMemo(
    () => [
      { accessorKey: "id", header: "Id", enableEditing: false },
      { accessorKey: "razon_Social", header: "Razon Social" },
      { accessorKey: "nit", header: "Nit" },
      { accessorKey: "direccion", header: "Direccion" },
      { accessorKey: "tipo_Institucion", header: "Tipo Institucion" },
      { accessorKey: "ciudad", header: "Ciudad" },
      { accessorKey: "departamento", header: "Departamento" },
      { accessorKey: "fecha_acreditacion", header: "Fecha Acreditacion" },
      { accessorKey: "fecha_renovacion", header: "Fecha Renovacion" },
      { accessorKey: "codigo_prestador", header: "Codigo Prestador" },
      { accessorKey: "telefono", header: "Telefono" },
      { accessorKey: "correo", header: "Correo" },
      { accessorKey: "mision", header: "Mision" },
      { accessorKey: "vision", header: "Vision" },
      { accessorKey: "principios", header: "Principios" },
      { accessorKey: "politicaSeguridad", header: "Politica Seguridad" },
      {
        accessorKey: "objetivosEstrategicos",
        header: "Objetivos Estrategicos",
      },
    ],
    [],
  );

  const [list1, setList1] = useState([]);

  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: obtenerInstituciones,
    })
      .then((res) => {
        setList1(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleSaveRow = async ({ exitEditingMode, row, values }) => {
    try {
      //buscar registro original
      const registroOriginal = list1.find((item) => item.id === values.id);

      //mezclar datos originales con los editados
      const dataFinal = {
        ...registroOriginal,
        ...values,
      };

      await axios({
        method: "put",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url:
          "https://suadesarrollo.azurewebsites.net/api/ActualizaInstitucion?Id=" +
          values.id,
        data: dataFinal,
      });

      alert("Actualizado con éxito");

      const nuevaLista = list1.map((item) =>
        item.id === values.id ? dataFinal : item,
      );

      setList1(nuevaLista);

      exitEditingMode();
    } catch (error) {
      console.log(error);
      alert("Error al actualizar");
    }
  };

  const [modalIsOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <div>
      <button className="btn btn-primary" onClick={openModal}>
        Informacion de las Instituciones
      </button>

      <ReactModal isOpen={modalIsOpen} onRequestClose={closeModal}>
        <div className="container-fluid">
          <div className="card shadow">
            <div className="card-header">
              <h6 className="font-weight-bold text-primary">Instituciones</h6>

              <MaterialReactTable
                columns={columns}
                data={list1}
                enableRowActions
                enableEditing
                editingMode="modal"
                onEditingRowSave={handleSaveRow}
                initialState={{ showColumnFilters: true }}
                localization={MRT_Localization_ES}
              />
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default CopyInstitucion;
